import { render, staticRenderFns } from "./perfectInBlack.vue?vue&type=template&id=9aaf6f2c"
import script from "./perfectInBlack.vue?vue&type=script&lang=js"
export * from "./perfectInBlack.vue?vue&type=script&lang=js"
import style0 from "./perfectInBlack.vue?vue&type=style&index=0&id=9aaf6f2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports